export enum MessageChannel {
  SMS = 'SMS',
  WEBPUSH = 'WEBPUSH',
  MAIL = 'MAIL',
}
